import { useAppSelector } from "../../app/hooks";
import { Box, Collapse, Paper } from "@mui/material";
import { selectPreference } from "../../features/preferences/preferencesSlice";
import { ListFilter } from "./ListFilter";

const sidebarWidth = 280;

interface Props {
  listType: string;
}

const FilterSidebar = ({ listType }: Props) => {
  const { isFilterOpen } = useAppSelector(selectPreference);

  return (
    <Collapse
      in={!!isFilterOpen}
      orientation="horizontal"
      timeout={250}
      unmountOnExit
    >
      <Box
        component={Paper}
        elevation={2}
        sx={{
          width: sidebarWidth,
          minWidth: sidebarWidth,
          height: "100%",
          overflowY: "auto",
          borderRadius: 2,
          flexShrink: 0,
        }}
      >
        <ListFilter listType={listType} />
      </Box>
    </Collapse>
  );
};

export default FilterSidebar;
